<script>
	import { getNumBackInUnits } from '$lib/util/util';
	import BigNumber from 'bignumber.js';

	import { currentMarket, fundingRateInterval } from '../store';
	import FundingRateInervalOption from './FundingRateInervalOption.svelte';

	let fundingRate = '';

	$: if ($currentMarket && $fundingRateInterval) {
		let fundingRateBn = new BigNumber($currentMarket.fundingRatePercentageLast1h);
		if ($fundingRateInterval == '24H') {
			fundingRateBn = fundingRateBn.multipliedBy(24);
		} else if ($fundingRateInterval == '1Y') {
			fundingRateBn = fundingRateBn.multipliedBy(24 * 365);
		}

		fundingRate = fundingRateBn.toString();
	}

	$: isFundingRatePositive = fundingRate && new BigNumber(fundingRate).gte(0);
</script>

<div class="hidden sm:flex items-end">
	<div class="hidden sm:flex flex-col items-start px-3 border-l-fx-grey-600 border-l ml-3">
		<div class="text-fx-grey-400 text-xs">Funding Rate</div>
		<div class="flex gap-2">
			<div
				class=" text-sm font-semibold"
				class:text-fx-green={isFundingRatePositive}
				class:text-fx-red={!isFundingRatePositive}
			>
				{#if $currentMarket}
					{getNumBackInUnits(fundingRate, 18, 6)}%
				{:else}
					-
				{/if}
			</div>
			<div class="flex text-fx-grey-200 text-xs gap-1 rounded-lg squircle-lg w-fit">
				<FundingRateInervalOption interval="1H" />
				<FundingRateInervalOption interval="24H" />
				<FundingRateInervalOption interval="1Y" />
			</div>
		</div>
	</div>
</div>
